import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import AnalyticsInjector from "@/components/AnalyticsInjector";
import SEOManager from "@/components/SEOManager";
import { useSettings } from "@/lib/settings";

export default function PublicLayout() {
  const { settings } = useSettings();
  const chatEnabled = settings?.chatbot_config?.enabled !== false;
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <SEOManager />
      <AnalyticsInjector />
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      {chatEnabled && <Chatbot />}
      <WhatsAppFloat />
    </div>
  );
}
